import { Component, Input, OnInit } from '@angular/core';
import { Stepper } from 'src/app/models/step/step.model';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent implements OnInit {

  @Input('steps') steps: Stepper[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
